/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddedRequestedData,
  CreateSecretarySchema,
  DoctorSignupStep2,
  DoctorSignupStep3,
  DoctorSignupStep4,
  DoctorSignupStep5,
  FacePhoto,
  GetSasTokenForDoctor,
  HTTPValidationError,
  KycLinkResponse,
  NationalIdPhoto,
  RefreshTokenResponse,
  ResponseMessage,
  SecretariesResponse,
  TransferredTokenResponse,
  DoctorOutAuthResponse,
} from '../models/index';
import {
    AddedRequestedDataFromJSON,
    AddedRequestedDataToJSON,
    CreateSecretarySchemaFromJSON,
    CreateSecretarySchemaToJSON,
    DoctorSignupStep2FromJSON,
    DoctorSignupStep2ToJSON,
    DoctorSignupStep3FromJSON,
    DoctorSignupStep3ToJSON,
    DoctorSignupStep4FromJSON,
    DoctorSignupStep4ToJSON,
    DoctorSignupStep5FromJSON,
    DoctorSignupStep5ToJSON,
    FacePhotoFromJSON,
    FacePhotoToJSON,
    GetSasTokenForDoctorFromJSON,
    GetSasTokenForDoctorToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    KycLinkResponseFromJSON,
    KycLinkResponseToJSON,
    NationalIdPhotoFromJSON,
    NationalIdPhotoToJSON,
    RefreshTokenResponseFromJSON,
    RefreshTokenResponseToJSON,
    ResponseMessageFromJSON,
    ResponseMessageToJSON,
    SecretariesResponseFromJSON,
    SecretariesResponseToJSON,
    TransferredTokenResponseFromJSON,
    TransferredTokenResponseToJSON,
    DoctorOutAuthResponseFromJSON,
    DoctorOutAuthResponseToJSON,
} from '../models/index';

export interface AddBulkPatientsV2Request {
    doctorId: string;
}

export interface AddedRequestedDataV2Request {
    addedRequestedData: AddedRequestedData;
}

export interface ConfirmSecretaryV2Request {
    otp: string;
    createSecretarySchema: CreateSecretarySchema;
}

export interface CreateSecretaryV2Request {
    createSecretarySchema: CreateSecretarySchema;
}

export interface DeleteSecretaryV2Request {
    secretaryId: string;
}

export interface DoctorSignupFacePhotoRequest {
    transferredToken: string;
    facePhoto: FacePhoto;
}

export interface DoctorSignupNationalIdPhotoRequest {
    transferredToken: string;
    nationalIdPhoto: NationalIdPhoto;
}

export interface DoctorSignupStep2V2Request {
    transferredToken: string;
    doctorSignupStep2: DoctorSignupStep2;
}

export interface GetSasTokenForDoctorByTransferTokenV2Request {
    transferredToken: string;
}

export interface KycLinkV2Request {
    transferredToken: string;
}

export interface KycStatusV2Request {
    transferredToken: string;
}

export interface LogoutV2Request {
    refreshToken: string;
}

export interface MyInfoUsingTransferTokenV2Request {
    transferredToken: string;
}

export interface RefreshTokenV2Request {
    refreshToken: string;
}

export interface SigninOtpConfirmV2Request {
    phoneNumber: string;
    otp: string;
}

export interface SigninOtpV2Request {
    phoneNumber: string;
}

export interface SignupStep3V2Request {
    transferredToken: string;
    doctorSignupStep3: DoctorSignupStep3;
}

export interface SignupStep4V2Request {
    transferredToken: string;
    doctorSignupStep4: DoctorSignupStep4;
}

export interface SignupStep5V2Request {
    transferredToken: string;
    doctorSignupStep5?: DoctorSignupStep5;
}

/**
 * 
 */
export class DoctorsV2Api extends runtime.BaseAPI {

    /**
     * Add Bulk Patients
     */
    async addBulkPatientsV2Raw(requestParameters: AddBulkPatientsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling addBulkPatientsV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/add_bulk_patients`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Add Bulk Patients
     */
    async addBulkPatientsV2(requestParameters: AddBulkPatientsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.addBulkPatientsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Added Requested Data
     */
    async addedRequestedDataV2Raw(requestParameters: AddedRequestedDataV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorOutAuthResponse>> {
        if (requestParameters['addedRequestedData'] == null) {
            throw new runtime.RequiredError(
                'addedRequestedData',
                'Required parameter "addedRequestedData" was null or undefined when calling addedRequestedDataV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/doctors/added_requested_data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddedRequestedDataToJSON(requestParameters['addedRequestedData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorOutAuthResponseFromJSON(jsonValue));
    }

    /**
     * Added Requested Data
     */
    async addedRequestedDataV2(requestParameters: AddedRequestedDataV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorOutAuthResponse> {
        const response = await this.addedRequestedDataV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Auth0 Otp
     */
    async auth0OtpV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/auth0_otp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Auth0 Otp
     */
    async auth0OtpV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.auth0OtpV2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Confirm Secretary
     */
    async confirmSecretaryV2Raw(requestParameters: ConfirmSecretaryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseMessage>> {
        if (requestParameters['otp'] == null) {
            throw new runtime.RequiredError(
                'otp',
                'Required parameter "otp" was null or undefined when calling confirmSecretaryV2().'
            );
        }

        if (requestParameters['createSecretarySchema'] == null) {
            throw new runtime.RequiredError(
                'createSecretarySchema',
                'Required parameter "createSecretarySchema" was null or undefined when calling confirmSecretaryV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['otp'] != null) {
            queryParameters['otp'] = requestParameters['otp'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/doctors/confirm_secretary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSecretarySchemaToJSON(requestParameters['createSecretarySchema']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseMessageFromJSON(jsonValue));
    }

    /**
     * Confirm Secretary
     */
    async confirmSecretaryV2(requestParameters: ConfirmSecretaryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseMessage> {
        const response = await this.confirmSecretaryV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Secretary
     */
    async createSecretaryV2Raw(requestParameters: CreateSecretaryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseMessage>> {
        if (requestParameters['createSecretarySchema'] == null) {
            throw new runtime.RequiredError(
                'createSecretarySchema',
                'Required parameter "createSecretarySchema" was null or undefined when calling createSecretaryV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/doctors/create_secretary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSecretarySchemaToJSON(requestParameters['createSecretarySchema']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseMessageFromJSON(jsonValue));
    }

    /**
     * Create Secretary
     */
    async createSecretaryV2(requestParameters: CreateSecretaryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseMessage> {
        const response = await this.createSecretaryV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete Secretary
     */
    async deleteSecretaryV2Raw(requestParameters: DeleteSecretaryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseMessage>> {
        if (requestParameters['secretaryId'] == null) {
            throw new runtime.RequiredError(
                'secretaryId',
                'Required parameter "secretaryId" was null or undefined when calling deleteSecretaryV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/doctors/secretaries/{secretary_id}`.replace(`{${"secretary_id"}}`, encodeURIComponent(String(requestParameters['secretaryId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseMessageFromJSON(jsonValue));
    }

    /**
     * Delete Secretary
     */
    async deleteSecretaryV2(requestParameters: DeleteSecretaryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseMessage> {
        const response = await this.deleteSecretaryV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Doctor Signup Face Photo
     */
    async doctorSignupFacePhotoRaw(requestParameters: DoctorSignupFacePhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorOutAuthResponse>> {
        if (requestParameters['transferredToken'] == null) {
            throw new runtime.RequiredError(
                'transferredToken',
                'Required parameter "transferredToken" was null or undefined when calling doctorSignupFacePhoto().'
            );
        }

        if (requestParameters['facePhoto'] == null) {
            throw new runtime.RequiredError(
                'facePhoto',
                'Required parameter "facePhoto" was null or undefined when calling doctorSignupFacePhoto().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['transferredToken'] != null) {
            queryParameters['transferred_token'] = requestParameters['transferredToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v2/doctors/doctor_signup_face_photo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FacePhotoToJSON(requestParameters['facePhoto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorOutAuthResponseFromJSON(jsonValue));
    }

    /**
     * Doctor Signup Face Photo
     */
    async doctorSignupFacePhoto(requestParameters: DoctorSignupFacePhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorOutAuthResponse> {
        const response = await this.doctorSignupFacePhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Doctor Signup National Id Photo
     */
    async doctorSignupNationalIdPhotoRaw(requestParameters: DoctorSignupNationalIdPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorOutAuthResponse>> {
        if (requestParameters['transferredToken'] == null) {
            throw new runtime.RequiredError(
                'transferredToken',
                'Required parameter "transferredToken" was null or undefined when calling doctorSignupNationalIdPhoto().'
            );
        }

        if (requestParameters['nationalIdPhoto'] == null) {
            throw new runtime.RequiredError(
                'nationalIdPhoto',
                'Required parameter "nationalIdPhoto" was null or undefined when calling doctorSignupNationalIdPhoto().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['transferredToken'] != null) {
            queryParameters['transferred_token'] = requestParameters['transferredToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v2/doctors/doctor_signup_national_id_photo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NationalIdPhotoToJSON(requestParameters['nationalIdPhoto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorOutAuthResponseFromJSON(jsonValue));
    }

    /**
     * Doctor Signup National Id Photo
     */
    async doctorSignupNationalIdPhoto(requestParameters: DoctorSignupNationalIdPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorOutAuthResponse> {
        const response = await this.doctorSignupNationalIdPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Doctor Signup Step2
     */
    async doctorSignupStep2V2Raw(requestParameters: DoctorSignupStep2V2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorOutAuthResponse>> {
        if (requestParameters['transferredToken'] == null) {
            throw new runtime.RequiredError(
                'transferredToken',
                'Required parameter "transferredToken" was null or undefined when calling doctorSignupStep2V2().'
            );
        }

        if (requestParameters['doctorSignupStep2'] == null) {
            throw new runtime.RequiredError(
                'doctorSignupStep2',
                'Required parameter "doctorSignupStep2" was null or undefined when calling doctorSignupStep2V2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['transferredToken'] != null) {
            queryParameters['transferred_token'] = requestParameters['transferredToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v2/doctors/doctor_signup_step2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DoctorSignupStep2ToJSON(requestParameters['doctorSignupStep2']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorOutAuthResponseFromJSON(jsonValue));
    }

    /**
     * Doctor Signup Step2
     */
    async doctorSignupStep2V2(requestParameters: DoctorSignupStep2V2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorOutAuthResponse> {
        const response = await this.doctorSignupStep2V2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Sas Token For Doctor
     */
    async getSasTokenForDoctorByTransferTokenV2Raw(requestParameters: GetSasTokenForDoctorByTransferTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSasTokenForDoctor>> {
        if (requestParameters['transferredToken'] == null) {
            throw new runtime.RequiredError(
                'transferredToken',
                'Required parameter "transferredToken" was null or undefined when calling getSasTokenForDoctorByTransferTokenV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['transferredToken'] != null) {
            queryParameters['transferred_token'] = requestParameters['transferredToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/get_sas_token_for_doctor_by_transfer_token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSasTokenForDoctorFromJSON(jsonValue));
    }

    /**
     * Get Sas Token For Doctor
     */
    async getSasTokenForDoctorByTransferTokenV2(requestParameters: GetSasTokenForDoctorByTransferTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSasTokenForDoctor> {
        const response = await this.getSasTokenForDoctorByTransferTokenV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Sas Token For Doctor
     */
    async getSasTokenForDoctorV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSasTokenForDoctor>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/doctors/get_sas_token_for_doctor`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSasTokenForDoctorFromJSON(jsonValue));
    }

    /**
     * Get Sas Token For Doctor
     */
    async getSasTokenForDoctorV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSasTokenForDoctor> {
        const response = await this.getSasTokenForDoctorV2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Get Secretaries
     */
    async getSecretariesV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecretariesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/doctors/secretaries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecretariesResponseFromJSON(jsonValue));
    }

    /**
     * Get Secretaries
     */
    async getSecretariesV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecretariesResponse> {
        const response = await this.getSecretariesV2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Kyc Link
     */
    async kycLinkV2Raw(requestParameters: KycLinkV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KycLinkResponse>> {
        if (requestParameters['transferredToken'] == null) {
            throw new runtime.RequiredError(
                'transferredToken',
                'Required parameter "transferredToken" was null or undefined when calling kycLinkV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['transferredToken'] != null) {
            queryParameters['transferred_token'] = requestParameters['transferredToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/kyc/link`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KycLinkResponseFromJSON(jsonValue));
    }

    /**
     * Kyc Link
     */
    async kycLinkV2(requestParameters: KycLinkV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KycLinkResponse> {
        const response = await this.kycLinkV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Kyc Status
     */
    async kycStatusV2Raw(requestParameters: KycStatusV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseMessage>> {
        if (requestParameters['transferredToken'] == null) {
            throw new runtime.RequiredError(
                'transferredToken',
                'Required parameter "transferredToken" was null or undefined when calling kycStatusV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['transferredToken'] != null) {
            queryParameters['transferred_token'] = requestParameters['transferredToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/kyc/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseMessageFromJSON(jsonValue));
    }

    /**
     * Kyc Status
     */
    async kycStatusV2(requestParameters: KycStatusV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseMessage> {
        const response = await this.kycStatusV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Logout
     */
    async logoutV2Raw(requestParameters: LogoutV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseMessage>> {
        if (requestParameters['refreshToken'] == null) {
            throw new runtime.RequiredError(
                'refreshToken',
                'Required parameter "refreshToken" was null or undefined when calling logoutV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refreshToken'] != null) {
            queryParameters['refresh_token'] = requestParameters['refreshToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseMessageFromJSON(jsonValue));
    }

    /**
     * Logout
     */
    async logoutV2(requestParameters: LogoutV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseMessage> {
        const response = await this.logoutV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * My Info Using Transfer Token
     */
    async myInfoUsingTransferTokenV2Raw(requestParameters: MyInfoUsingTransferTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorOutAuthResponse>> {
        if (requestParameters['transferredToken'] == null) {
            throw new runtime.RequiredError(
                'transferredToken',
                'Required parameter "transferredToken" was null or undefined when calling myInfoUsingTransferTokenV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['transferredToken'] != null) {
            queryParameters['transferred_token'] = requestParameters['transferredToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/my_info_using_transfer_token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorOutAuthResponseFromJSON(jsonValue));
    }

    /**
     * My Info Using Transfer Token
     */
    async myInfoUsingTransferTokenV2(requestParameters: MyInfoUsingTransferTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorOutAuthResponse> {
        const response = await this.myInfoUsingTransferTokenV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * My Info
     */
    async myInfoV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorOutAuthResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/doctors/my_info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorOutAuthResponseFromJSON(jsonValue));
    }

    /**
     * My Info
     */
    async myInfoV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorOutAuthResponse> {
        const response = await this.myInfoV2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Refresh Token
     */
    async refreshTokenV2Raw(requestParameters: RefreshTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RefreshTokenResponse>> {
        if (requestParameters['refreshToken'] == null) {
            throw new runtime.RequiredError(
                'refreshToken',
                'Required parameter "refreshToken" was null or undefined when calling refreshTokenV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refreshToken'] != null) {
            queryParameters['refresh_token'] = requestParameters['refreshToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/refresh_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefreshTokenResponseFromJSON(jsonValue));
    }

    /**
     * Refresh Token
     */
    async refreshTokenV2(requestParameters: RefreshTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RefreshTokenResponse> {
        const response = await this.refreshTokenV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Signin Otp Confirm
     */
    async signinOtpConfirmV2Raw(requestParameters: SigninOtpConfirmV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorOutAuthResponse>> {
        if (requestParameters['phoneNumber'] == null) {
            throw new runtime.RequiredError(
                'phoneNumber',
                'Required parameter "phoneNumber" was null or undefined when calling signinOtpConfirmV2().'
            );
        }

        if (requestParameters['otp'] == null) {
            throw new runtime.RequiredError(
                'otp',
                'Required parameter "otp" was null or undefined when calling signinOtpConfirmV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['phoneNumber'] != null) {
            queryParameters['phone_number'] = requestParameters['phoneNumber'];
        }

        if (requestParameters['otp'] != null) {
            queryParameters['otp'] = requestParameters['otp'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/signin_otp_confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorOutAuthResponseFromJSON(jsonValue));
    }

    /**
     * Signin Otp Confirm
     */
    async signinOtpConfirmV2(requestParameters: SigninOtpConfirmV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorOutAuthResponse> {
        const response = await this.signinOtpConfirmV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Signin Otp
     */
    async signinOtpV2Raw(requestParameters: SigninOtpV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseMessage>> {
        if (requestParameters['phoneNumber'] == null) {
            throw new runtime.RequiredError(
                'phoneNumber',
                'Required parameter "phoneNumber" was null or undefined when calling signinOtpV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['phoneNumber'] != null) {
            queryParameters['phone_number'] = requestParameters['phoneNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/signin_otp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseMessageFromJSON(jsonValue));
    }

    /**
     * Signin Otp
     */
    async signinOtpV2(requestParameters: SigninOtpV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseMessage> {
        const response = await this.signinOtpV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Doctor Signup Step3
     */
    async signupStep3V2Raw(requestParameters: SignupStep3V2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorOutAuthResponse>> {
        if (requestParameters['transferredToken'] == null) {
            throw new runtime.RequiredError(
                'transferredToken',
                'Required parameter "transferredToken" was null or undefined when calling signupStep3V2().'
            );
        }

        if (requestParameters['doctorSignupStep3'] == null) {
            throw new runtime.RequiredError(
                'doctorSignupStep3',
                'Required parameter "doctorSignupStep3" was null or undefined when calling signupStep3V2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['transferredToken'] != null) {
            queryParameters['transferred_token'] = requestParameters['transferredToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v2/doctors/doctor_signup_step3`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DoctorSignupStep3ToJSON(requestParameters['doctorSignupStep3']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorOutAuthResponseFromJSON(jsonValue));
    }

    /**
     * Doctor Signup Step3
     */
    async signupStep3V2(requestParameters: SignupStep3V2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorOutAuthResponse> {
        const response = await this.signupStep3V2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Doctor Signup Step4
     */
    async signupStep4V2Raw(requestParameters: SignupStep4V2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorOutAuthResponse>> {
        if (requestParameters['transferredToken'] == null) {
            throw new runtime.RequiredError(
                'transferredToken',
                'Required parameter "transferredToken" was null or undefined when calling signupStep4V2().'
            );
        }

        if (requestParameters['doctorSignupStep4'] == null) {
            throw new runtime.RequiredError(
                'doctorSignupStep4',
                'Required parameter "doctorSignupStep4" was null or undefined when calling signupStep4V2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['transferredToken'] != null) {
            queryParameters['transferred_token'] = requestParameters['transferredToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v2/doctors/doctor_signup_step4`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DoctorSignupStep4ToJSON(requestParameters['doctorSignupStep4']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorOutAuthResponseFromJSON(jsonValue));
    }

    /**
     * Doctor Signup Step4
     */
    async signupStep4V2(requestParameters: SignupStep4V2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorOutAuthResponse> {
        const response = await this.signupStep4V2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Doctor Signup Step5
     */
    async signupStep5V2Raw(requestParameters: SignupStep5V2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorOutAuthResponse>> {
        if (requestParameters['transferredToken'] == null) {
            throw new runtime.RequiredError(
                'transferredToken',
                'Required parameter "transferredToken" was null or undefined when calling signupStep5V2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['transferredToken'] != null) {
            queryParameters['transferred_token'] = requestParameters['transferredToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v2/doctors/doctor_signup_step5`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DoctorSignupStep5ToJSON(requestParameters['doctorSignupStep5']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorOutAuthResponseFromJSON(jsonValue));
    }

    /**
     * Doctor Signup Step5
     */
    async signupStep5V2(requestParameters: SignupStep5V2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorOutAuthResponse> {
        const response = await this.signupStep5V2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test
     */
    async testV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/doctors/test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Test
     */
    async testV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.testV2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Transfer Token
     */
    async transferTokenV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransferredTokenResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/doctors/transfer_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransferredTokenResponseFromJSON(jsonValue));
    }

    /**
     * Transfer Token
     */
    async transferTokenV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransferredTokenResponse> {
        const response = await this.transferTokenV2Raw(initOverrides);
        return await response.value();
    }

}
